import { shape, string } from 'prop-types';

export const RELATED_TAGS = shape({
    tagName: string,
    tagId: string,
    tagType: string,
});
